module.exports = __webpack_public_path__ + "sara-thumbnail.318233e0.jpg";